<div class="d-flex flex-column align-items-center">
  <div class="card mt-5 col-md-6 p-4 mr-0 p-gutter flex-auto max-w-[700px]">
    <div class="d-flex flex-column align-items-end" (click)="close()"> <span style="cursor: pointer;">&times;</span>
    </div>
    <h5>Copy Examination Questions for {{exam.examinationName}}</h5>
    <form class="mr-0 d-flex flex-column align-items-center" (ngSubmit)="copyQuestions()">
      <div class="mb-3 mr-0 col-md-10">
        <label class="form-label">Copy From</label>
        <ng-select class="form-select" [(ngModel)]="examFromId" [ngModelOptions]="{ standalone: true }">
          <ng-option selected value="0" disabled>Select Examination</ng-option>
          <ng-option *ngFor="let exam of examList" [value]="exam.id">{{exam.examinationName}}</ng-option>
        </ng-select>
      </div>
      <div class="mb-3 mr-0 col-md-10">
        <label class="form-label">Category</label>
        <ng-select class="form-select" [(ngModel)]="category" [ngModelOptions]="{ standalone: true }">
          <ng-option selected value="" disabled>Select Category</ng-option>
          <ng-option *ngFor="let cat of categoryList" [value]="cat.category">
            {{ cat.category }}
          </ng-option>
        </ng-select>
      </div>
      <button class="btn btn-primary btn-lg col-md-10" type="submit"> Copy
      </button>
    </form>
  </div>
</div>